import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function MarketingConsentToggle() {
  const [consent, setConsent] = useState(false);
  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/auth/marketing-consent")
      .then(({ data }) => {
        setConsent(!!data.marketing_consent);
        setDate(data.marketing_consent_at || null);
      })
      .finally(() => setLoading(false));
  }, []);

  const toggle = async () => {
    const next = !consent;
    setSaving(true);
    try {
      const { data } = await api.post("/auth/marketing-consent", { marketing_consent: next });
      setConsent(data.marketing_consent);
      setDate(data.marketing_consent_at);
      toast.success(next ? "Iscritto alla newsletter" : "Disiscritto dalla newsletter");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return null;

  return (
    <section
      data-testid="marketing-consent-toggle"
      className="card-surface p-5 flex items-start gap-4"
    >
      <div className="w-10 h-10 rounded-full bg-[#FFF8F0] flex items-center justify-center shrink-0">
        <Mail size={18} className="text-[#C05C45]" />
      </div>
      <div className="flex-1">
        <h3 className="font-display text-lg text-[#1A362D]">Newsletter di Per manina</h3>
        <p className="mt-1 font-ui text-xs text-[#5C6B64] leading-relaxed">
          {consent
            ? `Iscritto dal ${date ? new Date(date).toLocaleDateString("it-IT") : "—"}. Riceverai novità sui prodotti, guide e aggiornamenti.`
            : "Ricevi occasionalmente novità sui prodotti più amati e aggiornamenti dalla community."}
        </p>
      </div>
      <button
        onClick={toggle}
        disabled={saving}
        data-testid="marketing-consent-button"
        aria-pressed={consent}
        className={`relative inline-flex h-7 w-12 items-center rounded-full transition-colors disabled:opacity-50 ${
          consent ? "bg-[#1A362D]" : "bg-[#D9D5CE]"
        }`}
      >
        <span
          className={`inline-block h-5 w-5 transform rounded-full bg-white transition ${
            consent ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </button>
    </section>
  );
}
